var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h2',[_vm._v("SIMON")]),_c('router-link',{attrs:{"to":"/play","tag":"button"}},[_vm._v("Play")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }